import React, {useEffect, useState} from 'react'
import localization from "../../../../../../assets/localization/localization";
import Layout from "../../../../../../components/sales/layout/layout";
import DivLayout from "../../../../../../components/sales/divLayout/divLayout";
import ConstantInput from "../../../../../../components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";
import {toast} from "react-toastify";

const EditVariable = ({
                          match,
                          getValetContractInvoice,
                          valetContractInvoice = [],
                          lineItemsUpdate,
                          lineItems = []
                      }) => {

    const [listData, setListData] = useState([{}]);
    const [isLoading, setIsLoading] = useState(false);
    const [invoiceNo, setInvoiceNo] = useState(false);
    const [sum, setSum] = useState(0);


    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getValetContractInvoice(1, 2, null, match?.params?.invoice_id)
            setIsLoading(false)
        })()
    }, []);

    useEffect(() => {
        if (valetContractInvoice && valetContractInvoice?.resultSets && valetContractInvoice?.resultSets.length > 0) {
            setListData(valetContractInvoice?.resultSets[0]?.item_data)
            setInvoiceNo(valetContractInvoice?.resultSets[0]?.invoice_number)
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 500)
        }
    }, [valetContractInvoice])

    const handleInput = (key, index, val) => {
        let list = [...listData]
        list[index][key] = val
        setListData(list)
    }

    useEffect(() => {
        let list = [...listData]
        let s = 0;
        list.map(v => {
            s+= v?.amount * v?.men_days * v?.quantity
        })
        setSum(s)
    }, [listData])

    useEffect(() => {
        if (parseInt(lineItems?.status_code) !== 200) {
            toast.error(lineItems?.message)
        } else {
            toast.success(lineItems?.response?.message)
        }
    }, [lineItems])

    const handleSubmit = async () => {
        let isValidated = true
        let msg = '';
        listData.map(val => {
            if (parseInt(val?.is_variable) === 1 && (val?.men_days > 31 || val?.men_days <= 0)) {
                msg = "Men days can't be greater than 31 and less than 0 for item " + val?.description;
                isValidated = false
            }

            if (parseInt(val?.is_variable) === 1 && val?.amount <= 0) {
                msg = "Amount can't be in -ve and 0 for item " + val?.description;
                isValidated = false
            }

            if (parseInt(val?.is_variable) === 1 && val?.quantity <= 0) {
                msg = "Quantity can't be in -ve and 0 for item " + val?.description;
                isValidated = false
            }
        })

        const submitData = {line_items: listData, invoice_id: match?.params?.invoice_id, invoice_no: invoiceNo};
        if (!isValidated) {
            toast.warning(msg)
            return false
        }

        setIsLoading(true)
        await lineItemsUpdate(submitData)
        setIsLoading(false)
    }
    return (
        <>
            <Layout
                title={localization.valetServicesLineItems}
                isLoading={isLoading}
                isGoback={true}
            >
                {valetContractInvoice && valetContractInvoice?.resultSets && valetContractInvoice?.resultSets.length > 0 &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{localization.invoiceModule}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <DivLayout
                                        heading={"Invoice Id"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_id
                                        }
                                    />
                                    <DivLayout
                                        heading={"Invoice Number"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_number
                                        }
                                    />
                                    <DivLayout
                                        heading={"Invoice Date"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_date
                                        }
                                    />
                                    <DivLayout
                                        heading={"Invoice Type"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_type === 1 ? "Pre" : "Post"
                                        }
                                    />
                                    <DivLayout
                                        heading={"Net Payable"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.net_payable
                                        }
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{localization.lineItem}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <table className="table table-responsive">
                                        <thead>
                                            <th>Item</th>
                                            <th>Type</th>
                                            <th>Quantity</th>
                                            <th>Unit Price</th>
                                            <th>Men Days</th>
                                            <th>Total Men Days</th>
                                            <th>Total Price</th>
                                        </thead>
                                        <tbody>
                                        {listData !== undefined && listData.length > 0 && listData.map((val, i) => {
                                            return (
                                                <>
                                                    {val?.variable_type === 'O' &&
                                                        <tr>
                                                            <td>
                                                                {val?.description}
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.revenueType}
                                                                        value={'On Demand'}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.quantity}
                                                                        value={val.quantity}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            handleInput('quantity', i, value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.unitPrice}
                                                                        value={val.amount}
                                                                        type="text"
                                                                        handleChange={(values) =>
                                                                            handleInput('amount', i, values)
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.menDays}
                                                                        value={val.men_days}
                                                                        type="text"
                                                                        handleChange={(values) =>
                                                                            handleInput('men_days', i, values)
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={"Total Men Days"}
                                                                        value={val?.quantity * val?.men_days}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={"Total Price"}
                                                                        value={val?.quantity * val?.men_days * val.amount}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                    {val?.variable_type === 'V' &&
                                                        <tr>
                                                            <td>
                                                                {val?.description}
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.revenueType}
                                                                        value={'Variable'}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.quantity}
                                                                        value={val?.quantity}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.unitPrice}
                                                                        value={val.amount}
                                                                        type="text"
                                                                        handleChange={(values) =>
                                                                            handleInput('amount', i, values)
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.menDays}
                                                                        value={val.men_days}
                                                                        type="text"
                                                                        handleChange={(values) =>
                                                                            handleInput('men_days', i, values)
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={"Total Men Days"}
                                                                        value={val?.quantity * val?.men_days}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={"Total Price"}
                                                                        value={val?.quantity * val?.men_days * val.amount}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }

                                                    {val?.variable_type === 'F' &&
                                                        <tr>
                                                            <td>
                                                                {val?.description}
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.revenueType}
                                                                        value={'Fixed'}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.quantity}
                                                                        value={val?.quantity}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.unitPrice}
                                                                        value={val.amount}
                                                                        type="text"
                                                                        handleChange={(values) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={localization.menDays}
                                                                        value={val.men_days}
                                                                        type="text"
                                                                        handleChange={(values) =>
                                                                            handleInput('men_days', i, values)
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={"Total Men Days"}
                                                                        value={val?.quantity * val?.men_days}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={"Total Price"}
                                                                        value={val?.quantity * val?.men_days * val.amount}
                                                                        type="text"
                                                                        handleChange={(value) =>
                                                                            () => {
                                                                            }
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }

                                                </>
                                            )
                                        })
                                        }
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Sum</td>
                                            <td>{sum}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <center><Button onClick={handleSubmit}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </>
                }

            </Layout>
        </>
    )
}

export default EditVariable